import { useBlockProps } from '@wordpress/block-editor'
import { styleBreakpoints } from './lib/styleBreakpoints'

export default function Save({ attributes }) {
  const { blockId, breakPointSizes, blockSizes, doSiblingMaxWidth } = attributes

  return (
    <div id={`dualaxisspacer-block--wrapper-${blockId}`} {...useBlockProps.save()}>
      <style>{styleBreakpoints(blockId, blockSizes, doSiblingMaxWidth, breakPointSizes)}</style>
      <div id={`${blockId}`} className="dualaxisspacer-block"></div>
    </div>
  )
}
